import React, { useEffect, useRef, useState } from 'react'
import Layout from '../common/Layout'
import ApiHelper from '../../helperFunction/ApiHelper'
import API_ENDPOINTS from '../../helperFunction/Constant'
import { Link, useNavigate } from 'react-router-dom'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { Toast } from 'primereact/toast'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'


const HomeLayout = () => {

    const toast = useRef(null)
    const [homeLayoutData, setHomeLayoutData] = useState([])

    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const [orderIsChanged, setOrderIsChanged] = useState(false)

    const navigate = useNavigate()

    useEffect(() => {
        getHomeLayouts()
    }, [])

    const getHomeLayouts = () => {
        ApiHelper.get(API_ENDPOINTS.HOME_LAYOUT).then((res) => {
            if (res.status === 200) {
                setHomeLayoutData(res.data.data)
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const serialNoTemplate = (rowData, options) => { return options.rowIndex + 1; };

    const nameBodyTemplate = (rowData) => {
        return (
            rowData?.sectionHeading ? (
                <div style={{ display: "flex", alignItems: "center", gap: "10px", color:'blue', cursor:'pointer' }} onClick={() => navigate(`/home-layout/edit/${rowData.homeLayoutId}`)} >
                    {rowData?.sectionHeading}
                </div>
            ) : null
        );
    };

    const statusBodyTemplate = (rowData) => {
        return (
            <span className={`badge ${rowData.isActive ? 'bg-success' : 'bg-danger'}`}>
                {rowData.isActive ? 'Active' : 'Inactive'}
            </span>
        );
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <button onClick={() => navigate(`/home-layout/edit/${rowData.homeLayoutId}`)} className="btn btn-primary btn-sm me-2"> <i class="bi bi-pencil-square"></i> </button>
                <button onClick={() => confirmDeleteDailog(rowData.homeLayoutId)} className="btn btn-danger btn-sm"> <i class="bi bi-trash"></i> </button>
            </>
        );
    };

    const confirmDeleteDailog = (id) => {
        confirmDialog({
            message: 'Do you want to delete this record?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            defaultFocus: null,
            acceptClassName: 'p-button-danger',
            accept: () => deleteHomeLayout(id),
        });
    };

    const deleteHomeLayout = (id) => {
        ApiHelper.delete(`${API_ENDPOINTS.HOME_LAYOUT}/${id}`).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                getHomeLayouts()
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const renderHeader = () => {
        return (
            <div className="flex justify-content-end">
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={(e) => setGlobalFilterValue(e.target.value)} placeholder="Search" />
                </IconField>
            </div>
        );
    };

    const columns = [
        { field: 'Heading', body: nameBodyTemplate, header: 'sectionHeading' },
        { field: 'sectionType', header: 'Type' },
        { field: 'maxRecord', header: 'Max Records' },
        { header: 'Status', body: statusBodyTemplate },
        { header: 'Action', body: actionBodyTemplate }
    ];
    
    const dynamicColumns = columns.map((col, i) => {
        return <Column key={i} field={col.field} header={col.header} body={col.body} />
    }); 

    const handleRowReorder = (e) => {
        setHomeLayoutData(e.value);
        setOrderIsChanged(true)
    };

    const saveOrder = (id) => {
        const payload = homeLayoutData.map((item, index) => ({
            homeLayoutId: item.homeLayoutId,
            displayOrder: index + 1
        }));
        ApiHelper.post(`${API_ENDPOINTS.HOME_LAYOUT}/save-order`, payload).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setOrderIsChanged(false)
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    console.log('orderIsChanged: ', orderIsChanged);

    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <Layout>
                <div class="content-wrapper">
                    <div class="container-xxl flex-grow-1 container-p-y">
                        <div class="d-flex justify-content-between align-items-center py-3">
                            <h4 class="fw-bold py-3"><span class="text-muted fw-light"><p className="breadcrumb-item active mb-0" aria-current="page">Home Layout</p></span></h4>
                            <Link class="btn btn-primary" to={'/home-layout/add'} >Add New Layout</Link>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card mb-4">
                                    <div class="card-body">
                                        <DataTable reorderableRows onRowReorder={handleRowReorder} globalFilter={globalFilterValue} header={renderHeader} paginator rows={50} rowsPerPageOptions={[50, 100, 150, 200]} showGridlines size="small" value={homeLayoutData} tableStyle={{ minWidth: '50rem' }} >
                                            <Column rowReorder style={{ width: '3rem' }} />
                                            <Column body={serialNoTemplate} header='S.NO' />
                                            {dynamicColumns}
                                        </DataTable>
                                        <div className='mt-3'>
                                            <button className='btn btn-primary' disabled={!orderIsChanged} onClick={() => saveOrder()}>Save Order</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default HomeLayout
